import React from 'react';
import Inquires from '../../admin/components/Inquires';

export default function AgentInquiries() {
  return <Inquires isAgent={true} />;
}
